import { Box, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";

interface Props {
  readonly title: string;
  readonly description?: ReactNode;
  readonly children: ReactNode;
}

/** A titled block inside a report pane (e.g. a customer table), with an optional explanatory line. */
const ReportSubsection: FC<Props> = ({ title, description, children }) => (
  <Box sx={{ mt: 3 }}>
    <Typography variant="subtitle1" component="h3" sx={{ fontWeight: "bold", mb: 1 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
        {description}
      </Typography>
    )}
    {children}
  </Box>
);

export default ReportSubsection;
